// extracted by mini-css-extract-plugin
export var TeamCard = "TeamCard2-module--TeamCard--8OdND";
export var Name = "TeamCard2-module--Name--1aW0_";
export var Image = "TeamCard2-module--Image--3c18g";
export var TeamInfo = "TeamCard2-module--TeamInfo--12mrR";
export var BulletPoints = "TeamCard2-module--BulletPoints--1UPmE";